module.exports = __webpack_public_path__ + "img/brake-primary.02661b88.svg";